import React from 'react';

const Spinner = ({ size = 'md', color = 'red' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const colorClasses = {
    red: 'border-red-600',
    white: 'border-white',
    gray: 'border-gray-600',
    orange: 'border-orange-600'
  };

  return (
    <div className={`${sizeClasses[size]} border-4 ${colorClasses[color]} border-t-transparent rounded-full animate-spin`}></div>
  );
};

const LoadingOverlay = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <Spinner size="xl" color="red" />
      <p className="mt-4 text-gray-600 font-medium">{message}</p>
    </div>
  );
};

export { Spinner, LoadingOverlay };
